export function Spacing({
  size
}: {
  size: number;
}) {
  return <div style={{
    flex: 'none',
    height: size
  }} data-sentry-component="Spacing" data-sentry-source-file="Spacing.tsx" />;
}